/* [EZ] Tabbed Products — tab switching. Each panel holds its own ez-carousel
   (auto-initialised by ez-carousel.js); on tab change we show the panel and
   re-render its carousel so the track/progress measure correctly. */
(function () {
  'use strict';

  class EZTopPicks extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.ez-tp__tab'));
      this.panels = Array.from(this.querySelectorAll('.ez-tp__panel'));
      this.tabwrap = this.querySelector('[data-tp-tabwrap]');
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab));
      });

      // Mobile: mirror the tabs into a <select> (CSS shows it on mobile only). The global
      // bottom sheet (ez-bottom-sheet.js) turns it into the iOS-style sheet automatically.
      if (this.tabwrap && this.tabs.length) {
        this.select_el = document.createElement('select');
        this.select_el.className = 'ez-tp__tabselect';
        this.select_el.setAttribute('aria-label', 'Choose a collection');
        this.tabs.forEach((t) => {
          const opt = document.createElement('option');
          opt.value = t.dataset.tab;
          opt.textContent = t.textContent.trim();
          if (t.classList.contains('is-active')) opt.selected = true;
          this.select_el.appendChild(opt);
        });
        this.select_el.addEventListener('change', () => this.select(this.select_el.value));
        this.tabwrap.insertBefore(this.select_el, this.tabwrap.firstChild);
      }
    }

    select(id) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
      });
      if (this.select_el && this.select_el.value !== id) this.select_el.value = id;
      this.panels.forEach((p) => {
        const on = p.dataset.panel === id;
        p.classList.toggle('is-active', on);
        if (on) {
          const car = p.querySelector('[data-ez-carousel]');
          if (car && car.__ezCarousel) {
            car.__ezCarousel.index = 0;
            car.__ezCarousel.render();
          }
        }
      });
    }
  }

  if (!customElements.get('ez-top-picks')) {
    customElements.define('ez-top-picks', EZTopPicks);
  }
})();
